<template>
    <div class="modal-full">
        <div class='sm-modal-parent center-block'>
            <div
                class="modal-wrapper overflow-x-hidden overflow-y-auto inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
                <div class="modal-container relative w-auto my-6 mx-auto">
                    <!--content-->
                    <div
                        class="modal-content border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <!--header-->
                        <div
                            class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                            <h3 class="text-3xl font-semibold">
                                Отправить заявку
                            </h3>

                            <button
                                @click="modalClos"
                                class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none">
                                <span 
                                    class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                    ×
                                </span>
                            </button>
                        </div>
                        <!--body-->

                        <div class="relative px-3 flex-auto margin-t-15 overflow-y-auto" style="max-height: 70vh">

                            <div class='modal-form-schedule relative'>
                                <div class="relative">
                                    <!-- Group Selection -->
                                    <div class="form-group margin-bt-20">
                                        <label class="text-sm font-semibold text-gray-700 mb-2 block">Группа *</label>
                                        <model-select
                                            v-if="groups.length > 0"
                                            :options="getSelectOptionsBase(groups, 'uuid', 'name',)"
                                            v-model="groupUUID"
                                            :placeholder="'Выберите группу'">
                                        </model-select>
                                    </div>

                                    <!-- Training Method -->
                                    <div class="form-group margin-bt-20">
                                        <label class="text-sm font-semibold text-gray-700 mb-2 block">Метод обучения *</label>
                                        <model-select
                                            :options="getSelectOptionsBase(groupTypes, 'key', 'value',)"
                                            v-model="groupType"
                                            :placeholder="'Выберите метод'">
                                        </model-select>
                                    </div>

                                    <!-- IIN -->
                                    <div class="form-group margin-bt-20">
                                        <label class="text-sm font-semibold text-gray-700 mb-2 block">ИИН (12 цифр) *</label>
                                        <input
                                            v-model="iin"
                                            type="text"
                                            placeholder="Введите ИИН"
                                            maxlength="12"
                                            class="w-full h-10 border border-gray-300 px-3 py-2 placeholder-gray-400 text-gray-600 rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-emerald-500"
                                            @input="validateIIN"
                                        />
                                        <p v-if="iinError" class="text-red-500 text-xs mt-1">{{ iinError }}</p>
                                    </div>

                                    <!-- Criminal Record Certificate -->
                                    <div class="form-group margin-bt-20">
                                        <label class="text-sm font-semibold text-gray-700 mb-2 block">Справка о несудимости (PDF) *</label>
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            @change="onCriminalRecordCertSelected"
                                            class="w-full border border-gray-300 px-3 py-2 rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-emerald-500"
                                        />
                                        <p v-if="criminalRecordCertError" class="text-red-500 text-xs mt-1">{{ criminalRecordCertError }}</p>
                                        <p v-else-if="criminalRecordCertFile" class="text-green-600 text-xs mt-1">✓ {{ criminalRecordCertFile.name }}</p>
                                    </div>

                                    <!-- Narcology Certificate -->
                                    <div class="form-group margin-bt-20">
                                        <label class="text-sm font-semibold text-gray-700 mb-2 block">Справка из наркологического диспансера (PDF) *</label>
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            @change="onNarcologyCertSelected"
                                            class="w-full border border-gray-300 px-3 py-2 rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-emerald-500"
                                        />
                                        <p v-if="narcologyCertError" class="text-red-500 text-xs mt-1">{{ narcologyCertError }}</p>
                                        <p v-else-if="narcologyCertFile" class="text-green-600 text-xs mt-1">✓ {{ narcologyCertFile.name }}</p>
                                    </div>

                                    <!-- Psychiatry Certificate -->
                                    <div class="form-group margin-bt-20">
                                        <label class="text-sm font-semibold text-gray-700 mb-2 block">Справка из психоневрологического диспансера (PDF) *</label>
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            @change="onPsychiatryCertSelected"
                                            class="w-full border border-gray-300 px-3 py-2 rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-emerald-500"
                                        />
                                        <p v-if="psychiatryCertError" class="text-red-500 text-xs mt-1">{{ psychiatryCertError }}</p>
                                        <p v-else-if="psychiatryCertFile" class="text-green-600 text-xs mt-1">✓ {{ psychiatryCertFile.name }}</p>
                                    </div>

                                    <!-- ID Copy -->
                                    <div class="form-group margin-bt-20">
                                        <label class="text-sm font-semibold text-gray-700 mb-2 block">Копия удостоверения личности (PDF) *</label>
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            @change="onIDCopySelected"
                                            class="w-full border border-gray-300 px-3 py-2 rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-emerald-500"
                                        />
                                        <p v-if="idCopyError" class="text-red-500 text-xs mt-1">{{ idCopyError }}</p>
                                        <p v-else-if="idCopyFile" class="text-green-600 text-xs mt-1">✓ {{ idCopyFile.name }}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                        <!--footer-->
                        <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                            <button
                                @click="saveModalData"
                                :disabled="isSaving"
                                :class="[
                                    'font-bold uppercase text-sm px-6 py-3 rounded shadow outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150',
                                    isSaving
                                        ? 'bg-gray-400 text-white cursor-not-allowed'
                                        : 'bg-emerald-500 text-white active:bg-emerald-600 hover:shadow-lg'
                                ]"
                                type="button">
                                <span v-if="isSaving" class="flex items-center">
                                    <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Отправка...
                                </span>
                                <span v-else>Отправить</span>
                            </button>
                            <button
                                @click="modalClose"
                                :disabled="isSaving"
                                :class="[
                                    'font-bold uppercase text-sm px-6 py-3 rounded shadow outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150',
                                    isSaving
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-red-500 text-white active:bg-red-600 hover:shadow-lg'
                                ]"
                                type="button">
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="opacity-25 fixed inset-0 z-40 bg-black"></div> -->
        </div>
    </div>
</template>

<script>

import { API_CLIENT, HEADERS_TOKEN_JSON } from '@/const/uri';
import axios from 'axios';

import { getSelectOptionsBase } from '@/utils/base.js';
import { ModelSelect } from 'vue-search-select';
import { mapMutations } from 'vuex';

export default {
    components: {
        ModelSelect,
    },
    data() {
        return {
            groups: [],
            groupUUID: null,
            groupType: null,
            iin: '',
            iinError: '',
            criminalRecordCertFile: null,
            criminalRecordCertError: '',
            narcologyCertFile: null,
            narcologyCertError: '',
            psychiatryCertFile: null,
            psychiatryCertError: '',
            idCopyFile: null,
            idCopyError: '',
            groupTypes: [
                {
                    key: 'online',
                    value: 'онлайн',
                },
                {
                    key: 'offline',
                    value: 'офлайн',
                },
            ],
            labels: {
                group: 'Группа',
                group_type: 'Метод обучения',
                iin: 'ИИН',
                criminal_record_cert: 'Справка о несудимости',
                narcology_cert: 'Справка из наркологического диспансера',
                psychiatry_cert: 'Справка из психоневрологического диспансера',
                id_copy: 'Копия удостоверения личности',
            },
            isSaving: false,
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...mapMutations(['modalShow',]),
        getLabelEror(field_name) {
            return this.labels[field_name];
        },
        showErros(errors) {
            let allMessages = [];
            for (const key in errors) {
                var messages = typeof errors[key] == 'string' ? errors[key] : errors[key].join(', ');
                allMessages.push({
                'title': this.getLabelEror(key),
                'message': messages,
                });
            }
            this.modalShow({
                messages: allMessages,
                title: 'Проверьте данные формы',
                isError: true,
            });
        },
        getSelectOptionsBase,
        closeModal() {
            this.$parent.closCreateModal();
        },
        format(date) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        },
        validateIIN() {
            this.iinError = '';
            if (this.iin && !/^\d{12}$/.test(this.iin)) {
                this.iinError = 'ИИН должен состоять из 12 цифр';
            }
        },
        onCriminalRecordCertSelected(e) {
            const file = e.target.files?.[0];
            this.criminalRecordCertError = '';
            if (file) {
                if (!file.name.toLowerCase().endsWith('.pdf')) {
                    this.criminalRecordCertError = 'Файл должен быть в формате PDF';
                } else if (file.size > 10 * 1024 * 1024) {
                    this.criminalRecordCertError = 'Размер файла не должен превышать 10 МБ';
                } else {
                    this.criminalRecordCertFile = file;
                }
            }
        },
        onNarcologyCertSelected(e) {
            const file = e.target.files?.[0];
            this.narcologyCertError = '';
            if (file) {
                if (!file.name.toLowerCase().endsWith('.pdf')) {
                    this.narcologyCertError = 'Файл должен быть в формате PDF';
                } else if (file.size > 10 * 1024 * 1024) {
                    this.narcologyCertError = 'Размер файла не должен превышать 10 МБ';
                } else {
                    this.narcologyCertFile = file;
                }
            }
        },
        onPsychiatryCertSelected(e) {
            const file = e.target.files?.[0];
            this.psychiatryCertError = '';
            if (file) {
                if (!file.name.toLowerCase().endsWith('.pdf')) {
                    this.psychiatryCertError = 'Файл должен быть в формате PDF';
                } else if (file.size > 10 * 1024 * 1024) {
                    this.psychiatryCertError = 'Размер файла не должен превышать 10 МБ';
                } else {
                    this.psychiatryCertFile = file;
                }
            }
        },
        onIDCopySelected(e) {
            const file = e.target.files?.[0];
            this.idCopyError = '';
            if (file) {
                if (!file.name.toLowerCase().endsWith('.pdf')) {
                    this.idCopyError = 'Файл должен быть в формате PDF';
                } else if (file.size > 10 * 1024 * 1024) {
                    this.idCopyError = 'Размер файла не должен превышать 10 МБ';
                } else {
                    this.idCopyFile = file;
                }
            }
        },
        validateForm() {
            if (!this.groupUUID) {
                this.showErros({ group: 'Выберите группу' });
                return false;
            }
            if (!this.groupType) {
                this.showErros({ group_type: 'Выберите метод обучения' });
                return false;
            }
            if (!this.iin || !/^\d{12}$/.test(this.iin)) {
                this.showErros({ iin: 'ИИН должен состоять из 12 цифр' });
                return false;
            }
            if (!this.criminalRecordCertFile) {
                this.showErros({ criminal_record_cert: 'Загрузите справку о несудимости' });
                return false;
            }
            if (!this.narcologyCertFile) {
                this.showErros({ narcology_cert: 'Загрузите справку из наркологического диспансера' });
                return false;
            }
            if (!this.psychiatryCertFile) {
                this.showErros({ psychiatry_cert: 'Загрузите справку из психоневрологического диспансера' });
                return false;
            }
            if (!this.idCopyFile) {
                this.showErros({ id_copy: 'Загрузите копию удостоверения личности' });
                return false;
            }
            return true;
        },
        async loadData() {
            await axios({
                method: "GET",
                data: {},
                url: API_CLIENT.course + this.$props.uuid + '/groups/',
                headers: HEADERS_TOKEN_JSON(),
            }).then((e) => {
                this.groups = e.data.data;
            }).catch(function (e) {
                console.log(e);
            });
        },
        async saveModalData() {
            if (this.isSaving) return;
            if (!this.validateForm()) {
                return;
            }

            this.isSaving = true;

            const formData = new FormData();
            formData.append('group', this.groupUUID);
            formData.append('group_type', this.groupType);
            formData.append('iin', this.iin);
            formData.append('criminal_record_cert', this.criminalRecordCertFile);
            formData.append('narcology_cert', this.narcologyCertFile);
            formData.append('psychiatry_cert', this.psychiatryCertFile);
            formData.append('id_copy', this.idCopyFile);

            try {
                await axios({
                    method: "POST",
                    data: formData,
                    url: API_CLIENT.course + this.$props.uuid + '/groups/',
                    headers: {
                        ...HEADERS_TOKEN_JSON(),
                        'Content-Type': 'multipart/form-data',
                    },
                });
                this.$props.modalClose();
                this.$router.push({
                    name: 'ClientCourseSatus',
                });
            } catch (e) {
                const status = e.response?.status;
                if ([400, 404, 403].includes(status)) {
                    const data = e.response.data;
                    const errors = data.errors || data.detail;
                    this.showErros(errors);
                } else {
                    this.showErros({ server: 'Ошибка сервера, обратитесь в техподдержку' });
                }
            } finally {
                this.isSaving = false;
            }
        },
    },
    props: {
        uuid: {},
        modalClose: {},
    },
}
</script>

<style>
</style>